<template>
  <div class="homePage">
    <div class="top">
      <img class="homeBg" src="@/assets/image/bannerBg.png" mode="scaleToFill" />
      <div style="
          position: absolute;
          width: 1400px;
          top: 11vw;
          left: 50%;
          transform: translateX(-50%);
        ">
        <img class="homeTitle" src="@/assets/image/标题.png" />
      </div>
      <!-- 顶部区域 -->
      <div class="topArea">
        <div class="fxedTop">
          <div class="container">
            <div class="row" style="margin-bottom: 20px">
              <div style="height: 40px"></div>
              <div class="rowRight">
                <div class="login">
                  <div style="display: flex; align-items: center">
                    <span style="
                        font-size: 20px;
                        font-weight: bold;
                        color: red;
                        margin: 0 20px;
                        font-size: 24px;
                      ">客服电话: 400-133-5833</span>
                  </div>
                  <div>
                    <a :href="aHref" target="_blank" style="
                        display: block;
                        color: #fff;
                        text-decoration: none;
                        border: 1px solid #fff;
                        border-radius: 5px;
                        padding: 2px 10px;
                        margin-right: 20px;
                        font-size: 20px;
                      ">管理员登录</a>
                  </div>
                  <div v-if="userInfo && userInfo?.realName" style="display: flex; align-items: center">
                    <img :src="userInfo.certificateHeadPhoto" alt="" style="
                        width: 30px;
                        height: 30px;
                        border-radius: 30px;
                        margin-right: 10px;
                      " />
                    <div style="color: #fff">{{ userInfo.realName }}</div>
                  </div>
                  <div v-else class="userInfo" style="font-size: 20px" @click="showLogin">
                    学员登录
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="rowLeft">
                <div class="menuItem" v-for="(item, index) in navList" :key="index" @click="handleUrl(item)">
                  <div class="menuName">
                    <div style="flex: 1">
                      <div style="margin-bottom: 6px">{{ item.name }}</div>
                      <div v-if="item.isActive" class="menuActive"></div>
                    </div>
                    <div v-if="item.isLine" class="borderR" style="height: 20px"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- CMS + 登录 -->
        <!-- <div class="loginquanxian">
          <div class="login" v-if="!userInfo.realName">
            <Login></Login>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 流程菜单 -->
    <div class="menu">
      <div v-for="(item, index) in menuItems" :key="index" style="display: flex; align-items: center">
        <div class="item" @click="navToUrl(item)">
          <img :src="item.iconUrl" />
          <div>{{ item.name }}</div>
        </div>
        <div class="jiantou" v-if="menuItems.length - 1 != index">
          <img src="@/assets/image/箭头.png" alt="" style="width: 50px" />
        </div>
      </div>
    </div>

    <div style="width: 100%; background: #e6eef7">
      <div style="width: 1400px; margin: 0 auto; margin-bottom: 40px" v-if="noticeList.length > 0">
        <RollingNotice :notices="noticeList" :speed="3000" :pause-on-hover="true" />
      </div>
    </div>
    <div class="cmsList">
      <Cms title="通知公告" :list="noticeList" @more="navUrl(`/noticeList`)" @click="handleDetails"></Cms>
      <!-- <Cms
        title="动态新闻"
        :list="newsList"
        @more="navUrl(`/newsList`)"
        @click="handleDetails"></Cms>
      <Cms
        title="相关政策"
        :list="policyList"
        @more="navUrl(`/policyList`)"
        @click="handleDetails"></Cms> -->
    </div>
    <!-- 在线课程 -->
    <div>
      <div class="mian">
        <div class="title">
          <img class="zhuangshi" src="@/assets/image/装饰.png" />
          <div class="name">公需课程</div>
          <div class="dynamic">/ PUBLIC COURSE</div>
        </div>
        <div class="flex-row" v-if="curriculumList.length > 0">
          <div class="itemFlex" v-for="(item, index) in curriculumList" :key="index">
            <div class="itemBody">
              <img v-if="item.requiredType == 1" class="itemLogo" src="@/assets/image/必修.png" />
              <img v-if="item.requiredType == 2" class="itemLogo" src="@/assets/image/选修.png" />
              <img class="groupUp" :src="item.logo ? item.logo : noImg" alt="" />
              <div class="groupBottom">
                <div class="title">{{ item.name }}</div>
                <!-- <div class="bottomGrayText">
                  {{ item.introduction }}
                </div> -->
                <div class="bottomGrayText">
                  <!-- <span> 课时: {{ item.classHour }} (分钟) </span> -->
                </div>

                <div class="groupLecturer">
                  <div>
                    <span style="margin-right: 10px">讲师: {{ item.lecturer }}</span>
                    <span> 学时: {{ item.learnHour }} </span>
                  </div>
                  <div v-if="item.isJoin == 1" class="seeDetails" @click="detailSel(index)">
                    查看课程
                  </div>
                  <div v-else class="seeDetails" @click="addClass(item)">
                    加入课程
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <Footer></Footer>
    </div>
    <!-- <div class="contact1" @click="dialogVisible = true">联系我们</div> -->

    <!-- 联系我们弹框 -->
    <div class="contactUs" v-show="dialogVisible">
      <div class="contactBg" @click="dialogVisible = false"></div>
      <div class="contact">
        <img class="guanbi" @click="dialogVisible = false" src="@/assets/image/关闭.png" />
        <div class="title">联系我们</div>
        <img src="@/assets/image/1241755506357_.pic.jpg" style="width: 500px" />
        <div style="padding: 0 36px; box-sizing: border-box; padding-bottom: 40px">
          <div style="margin-bottom: 10px">联系电话: 4001335833</div>
          <div>工作时间: 工作日周一到周五 (9:30-13:00,15:30-18:00)</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
import * as cmsApi from "@/api/cms";
import { getGroup, joinClassGroup } from "@/api/wkApi.js";
import * as userApi from "@/api/user";
import Login from "./login.vue";
import RollingNotice from "@/components/RollingNotice";
import Cms from "@/components/cms";

export default {
  components: {
    FxedTop,
    Footer,
    Login,
    RollingNotice,
    Cms,
  },
  data() {
    return {
      dialogVisible: false,
      aHref: window.origin + "/admin/#/",
      noImg: require("@/assets/noImg.webp"),
      navList: [
        {
          name: "首页",
          toUrl: "/",
          isToUrl: true,
          isActive: true,
          isLine: true,
        },
        {
          name: "在线课程",
          toUrl: "/course",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "通知公告",
          toUrl: "/noticeList",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "线下培训认定",
          toUrl: "/datarmine",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "下载专区",
          toUrl: "/policyList",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "联系我们",
          toUrl: "/HelpCenter",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "个人中心",
          toUrl: "/my",
          isToUrl: true,
          isActive: false,
          isLine: false,
        },
      ],
      searchValue: "",
      menuItems: [
        {
          id: "1857409322166403099",
          name: "学员注册",
          iconUrl: require("@/assets/menus/01.png"),
          clickType: 1,
          toUrl: "无",
          sort: 1,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1857409535631310899",
          name: "填写资料",
          iconUrl: require("@/assets/menus/02.png"),
          clickType: 1,
          toUrl: "/my",
          sort: 2,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1857409873578967099",
          name: "选择课程",
          iconUrl: require("@/assets/menus/03.png"),
          clickType: 1,
          toUrl: "/course",
          sort: 4,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1902390627000561699",
          name: "在线学习",
          iconUrl: require("@/assets/menus/04.png"),
          clickType: 1,
          toUrl: "/course",
          sort: 5,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1902390732889960499",
          name: "在线考试",
          iconUrl: require("@/assets/menus/05.png"),
          clickType: 1,
          toUrl: "/my",
          sort: 6,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1950212137677139969",
          name: "打印证书",
          iconUrl: require("@/assets/menus/06.png"),
          clickType: 1,
          toUrl: "/my",
          sort: 7,
          showFlag: 1,
          delFlag: 0,
        },
        {
          id: "1902390833016385599",
          name: "取得证书",
          iconUrl: require("@/assets/menus/07.png"),
          clickType: 1,
          toUrl: "/my",
          sort: 8,
          showFlag: 1,
          delFlag: 0,
        },
      ],
      // 通知公告数组
      noticeList: [],
      // 动态新闻数组
      newsList: [],
      // 相关政策数组
      policyList: [],

      curriculumList: [],
      userInfo: {},
      titleList: [
        {
          title: "动态新闻",
          type: 1,
        },
        {
          title: "公告通知",
          type: 2,
        },
        {
          title: "相关政策",
          type: 3,
        },
      ],
      currentType: 1,
      emitText: "",
    };
  },
  async created() {
    this.getIndex();
    this.getUserInfo();
  },
  methods: {
    // 加入课程
    async addClass(item) {
      this.loading = true;
      const res = await joinClassGroup({
        classGroupId: item.classGroupId,
      });
      if (res.code == 200) {
        item.isJoin = 1;
        this.loading = false;
        this.$message.success(res.result);
      } else {
        this.$message.warning("请先登录系统!");
      }
    },
    showLogin() {
      if (this.$route.path === "/login") {
        return;
      }
      this.$router.push({ path: "/login" });
    },
    handleUrl(item, index) {
      if (item && item.isToUrl) {
        if (this.$route.fullPath === item.toUrl) {
          return;
        }
        this.$router.push(item.toUrl);
      }
    },
    handleCourse() {
      if (this.$route.path === "/course") {
        return;
      }
      this.$router.push("/course");
    },
    async navToUrl(item) {
      try {
        let res = await userApi.getUserInfo();
        if (res.code == 200 && res.data && res.data.userToken) {
          this.$router.push(item.toUrl);
        }
      } catch (error) { }
    },
    handleDetails(item) {
      this.$router.push({
        path: "/details",
        query: { articleId: item.id },
      });
    },
    // 路由跳转
    navUrl(url) {
      this.$router.push(url);
    },
    detailSel(index) {
      this.$router.push({
        path: "/courseDetails",
        query: { classGroupId: this.curriculumList[index].classGroupId },
      });
    },
    async getUserInfo() {
      try {
        let res = await userApi.getUserInfo();
        if (res.code == 200 && res.data && res.data.userToken) {
          res.data.realName = res.data.realName.slice(0, 1) + "**";
          this.userInfo = res.data;
        } else {
          this.userInfo = {};
        }
      } catch (error) { }
    },
    // 获取课程列表
    async getGroup(params) {
      try {
        let res = await getGroup({ ...params, courseType: 1, pageSize: 12, classYear: 2025 });
        if (res.result.total == 0 && params.searchKeyword) {
          this.$message.warning("没有搜索到相关课程");
        }

        if (res.result.records) {
          res.result.records.forEach((item) => {
            if (item.logo) {
              item.logo = item.logo.replace(
                "https://xzzhuanji.cn/ework/",
                "https://zwyun.xzzhuanji.cn:18443/zhuanji/"
              );
              item.logo = item.logo.replace("/202508", "");
            }
          });
        }
        this.curriculumList = res.result.records;
      } catch (error) { }
    },
    async getIndex() {
      try {
        let menu = await cmsApi.getMenu({
          moduleId: "1857408826160594999",
        });
        this.menuItems = menu.result.list;
        this.queryNews();
        this.getGroup();
      } catch (error) {
        console.log(error);
      }
    },
    async queryNews() {
      // 新闻
      // let article2 = await cmsApi.getArticleType({
      //   pageSize: 5,
      //   columnId: "1862393710348255299",
      //   moduleId: "1862393481452503099",
      //   type: 2,
      // });
      // this.newsList = article2.result.list;
      // // 公告
      let article = await cmsApi.getArticleType({
        pageSize: 5,
        columnId: "1862393710348255299",
        moduleId: "1862393481452503099",
        type: 2,
      });
      this.noticeList = article.result.list;
      // // 政策
      // let article3 = await cmsApi.getArticleType({
      //   pageSize: 5,
      //   columnId: "1862393710348255299",
      //   moduleId: "1862393481452503099",
      //   type: 2,
      // });
      // this.policyList = article3.result.list;
    },
  },
};
</script>

<style lang="scss" scoped>
.contactUs {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 991;

  .contactBg {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  .contact {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    background: #fff;
    border-radius: 10px;
    z-index: 1;
    width: 500px;
    display: flex;
    flex-direction: column;
    font-size: 16px;

    .title {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      padding-top: 20px;
    }
  }
}

.contact1 {
  position: fixed;
  width: 20px;
  right: 20px;
  bottom: 20vh;
  background: #65a3ea;
  text-align: center;
  padding: 10px 2px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  z-index: 909;
}

.groupLecturer {
  display: flex;
  justify-content: space-between;

  font-weight: 400;
  font-size: 14px;
  color: #9b9b9b;

  .seeDetails {
    cursor: pointer;
    color: #3465b8;
  }
}

.homePage {
  position: relative;

  .top {
    width: 100vw;
    position: relative;

    .homeBg {
      width: 100vw;
      display: block;
      position: relative;
    }

    .homeTitle {
      width: 35vw;
      position: absolute;
      left: 40px;
      top: 0;
    }

    .homeText {
      position: relative;
      width: 1400px;
      margin: 0 auto;
      height: 325px;
      margin-bottom: 180px;

      img {
        display: block;
      }
    }

    .topArea {
      position: absolute;
      top: 0;
      z-index: 1;
    }

    .fxedTop {
      font-size: 14px;
      width: 100vw;

      .container {
        padding-top: 20px;
        width: 1400px;
        margin: 0 auto;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .rowLeft {
            width: 1400px;
            display: flex;
            align-items: center;
            flex: 1;
            height: 100%;
            box-sizing: border-box;
            border-radius: 30px 0 30px 0;
            overflow: hidden;

            .menuItem {
              flex: 1;

              .menuName {
                text-align: center;
                font-size: 20px;
                color: #ffffff;
                cursor: pointer;
                display: flex;
                align-items: center;

                .menuActive {
                  width: 60%;
                  margin: 0 auto;
                  height: 4px;
                  border-radius: 4px;
                  background: #fff;
                }
              }
            }
          }

          .rowRight {
            display: flex;
            align-items: center;

            .search {
              width: 450px;
              height: 48px;
              overflow: hidden;
              background: #f5f5f5;
              border-radius: 50px;
              position: relative;
              z-index: 2;
              display: flex;
              margin-right: 30px;

              .searchInput {
                padding-left: 20px;
                box-sizing: border-box;
                border: none;
                background: #f5f5f5;
                border-radius: 50px;
                flex: 1;
                line-height: 48px;
                color: #ccc;
                font-size: 14px;
              }

              .searchIcon {
                width: 32px;
                height: 32px;
                padding: 12px;
                margin-right: 20px;
                box-sizing: border-box;

                img {
                  width: 20px;
                  height: 20px;
                }
              }
            }

            .cart {
              width: 20px;
              height: 20px;
              margin-right: 30px;
              position: relative;

              &:hover {
                cursor: pointer;
              }

              img {
                width: 100%;
                height: 100%;
              }

              .cartNum {
                width: 20px;
                height: 20px;
                background-color: red;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                color: #fff;
                border-radius: 20px;
                position: absolute;
                top: -50%;
                right: -50%;
              }
            }

            .login {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              box-sizing: border-box;

              .userInfo {
                display: flex;
                align-items: center;
                font-weight: 400;
                color: #fff;
                cursor: pointer;
                border: 1px solid #fff;
                border-radius: 5px;
                padding: 2px 10px;

                .avatarUrl {
                  width: 30px;
                  height: 30px;
                  border-radius: 30px;
                }

                .realName {
                  margin-left: 10px;
                  color: #fff;
                }
              }

              .loginItem {
                padding: 0 10px;
                font-size: 16px;
                color: #0d6fc2;

                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }

  .loginquanxian {
    position: relative;
    width: 1400px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding-top: 40px;
    padding-bottom: 100px;
    box-sizing: border-box;
    display: flex;
    // 右对齐
    justify-content: flex-end;
  }

  .cmsList {
    position: relative;
    width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 31px;
    margin-bottom: 40px;
  }

  .menu {
    position: relative;
    margin: 0 auto;
    margin-top: -120px;
    margin-bottom: 40px;
    border-radius: 10px;
    width: 1400px;
    height: 170px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    // padding: 0 60px;
    box-sizing: border-box;

    .item {
      text-align: center;
      cursor: pointer;

      img {
        width: 78px;
        height: 78px;
        margin-bottom: 10px;
      }
    }

    .jiantou {
      margin: 0 30px;
      margin-top: -30px;
    }
  }

  .mian {
    position: relative;
    width: 1400px;
    margin: 0 auto;
    padding-top: 10px;
    padding-bottom: 30px;

    .title {
      display: flex;
      align-items: flex-end;
      position: relative;
      margin-bottom: 20px;

      .zhuangshi {
        position: absolute;
        left: 0;
        top: -10px;
      }

      .name {
        font-weight: bold;
        font-size: 30px;
        color: #0d6fc2;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        padding-left: 10px;
        margin-right: 10px;
      }

      .dynamic {
        font-weight: normal;
        font-size: 14px;
        color: #9b9b9b;
      }
    }

    .flex-row {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;

      // flex间隔
      .itemFlex {
        width: 327px;
        border-radius: 5px;
        overflow: hidden;
      }

      .itemBody {
        display: flex;
        background: white;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;

        .itemLogo {
          position: absolute;
          left: -3px;
          top: -3px;

          width: 80px;
          height: 80px;
        }

        .groupUp {
          width: 380px;
          height: 220px;
          background: #d8d8d8;
          margin-bottom: 10px;
        }

        .groupBottom {
          width: 92%;
          display: flex;
          flex-direction: column;
          padding-bottom: 10px;
          position: relative;

          .title {
            width: 320px;

            font-weight: normal;
            font-size: 18px;
            color: #4a4a4a;
            margin-bottom: 10px;
            // 超出两行显示...
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            /* 限制显示的行数 */
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .bottomGrayText {
            font-weight: 400;
            font-size: 16px;
            color: #9b9b9b;
            // 超出1行显示...
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .bottomPrice {
            font-weight: normal;
            font-size: 18px;
            color: #7ed321;
          }

          .bottomPrice2 {
            font-weight: normal;
            font-size: 18px;
            color: #d91715;
          }
        }
      }
    }
  }
}
</style>
